import useEducatorCuratedPlaylist from '@cont/Content/FreeLesson/useEducatorCuratedPlaylist';
import useProfile from './useProfile';
import useProfileStats from './useProfileStats';
import useLearnerCoursesInfo from './useLearnerCoursesInfo';
import useLearnerMileStonesInfo from './useLearnerMileStonesInfo';
import useLevelDisplayInfo from './useLevelDisplayInfo';
import useProfileFeed from './useProfileFeed';

export const useFullProfileInfoNew = ({ username, fallbackData }) => {
  const { key: profileDataKey, profileData } = useProfile(username, {
    fallbackData: fallbackData.profileData
  });

  const { key: profileStatsKey, profileStats } = useProfileStats(username, {
    fallbackData: fallbackData.profileStats
  });

  const { key: levelDisplayInfoKey, levelsDisplayInfo } = useLevelDisplayInfo({
    fallbackData: fallbackData.levelsDisplayInfo
  });

  return {
    // SWR Keys for caching
    keys: {
      profileDataKey,
      profileStatsKey,
      levelDisplayInfoKey
    },
    // Data for usage
    profileData,
    profileStats,
    levelsDisplayInfo
  };
};

const useFullProfileInfo = ({ username, fallbackData, authorUID }) => {
  const { key: profileDataKey, profileData } = useProfile(username, {
    fallbackData: fallbackData.profileData
  });

  const { key: profileStatsKey, profileStats } = useProfileStats(username, {
    fallbackData: fallbackData.profileStats
  });

  const { key: profileFeedKey, profileFeed } = useProfileFeed(username, {
    fallbackData: fallbackData.profileFeed
  });

  const { key: learnerCoursesInfoKey, learnerCoursesInfo } =
    useLearnerCoursesInfo(username, {
      fallbackData: fallbackData.learnerCoursesInfo
    });

  const { key: learnerMileStonesInfokey, learnerMileStonesInfo } =
    useLearnerMileStonesInfo(username, {
      fallbackData: fallbackData.learnerMileStonesInfo
    });

  const { key: levelDisplayInfoKey, levelsDisplayInfo } = useLevelDisplayInfo({
    fallbackData: fallbackData.levelsDisplayInfo
  });

  const { key: curatedPlaylistDataKey, curatedPlaylistData } =
    useEducatorCuratedPlaylist(authorUID, {
      fallbackData: fallbackData.curatedPlaylistData
    });

  return {
    // SWR Keys for caching
    keys: {
      profileDataKey,
      profileStatsKey,
      levelDisplayInfoKey,
      profileFeedKey,
      learnerCoursesInfoKey,
      learnerMileStonesInfokey,
      curatedPlaylistDataKey
    },
    // Data for usage
    profileData,
    profileStats,
    levelsDisplayInfo,
    profileFeed,
    learnerCoursesInfo,
    learnerMileStonesInfo,
    curatedPlaylistData
  };
};

export default useFullProfileInfo;
